module.exports = __webpack_public_path__ + "static/img/topcustomer.e591f0bf.png";